var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErrorMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 50,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 30,
  x: 1,
  y: 1,
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  rx: 7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon)",
  d: "M9.519 37.563a1.08 1.08 0 0 1 1.896 0l5.908 10.84a1.08 1.08 0 0 1-.948 1.596H4.55a1.08 1.08 0 0 1-.948-1.597z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon-strong)",
  fillRule: "evenodd",
  d: "M10.463 41.492a.75.75 0 0 1 .75.75v2.156a.75.75 0 0 1-1.5 0v-2.156a.75.75 0 0 1 .75-.75",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon-strong)",
  d: "M11.271 46.824a.809.809 0 1 1-1.617 0 .809.809 0 0 1 1.617 0"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 127.433,
  height: 4,
  x: 26.551,
  y: 42.016,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})));
export default SvgErrorMessage;